import React 				from 'react';
import PropTypes 			from 'prop-types';

import HiddenScroll 		from '../common/_HiddenScroll.jsx';
import SimpleProductCard 	from '../common/_SimpleProductCard.jsx';

import {onEscapePress} 		from '../common/_Utilities.jsx';

export default class AddToCartModal extends React.Component
{
	constructor(props) 
	{
		super(props);
	}

	componentDidMount() 
	{
		onEscapePress(() => this.props.func.toggleModal());
	}

	componentDidUpdate() 
	{
		onEscapePress(() => this.props.func.toggleModal());
	}

	render() 
	{
		const {classes = '', product, storeName} = this.props;
		const moreProducts = this.props.moreProducts ? this.props.moreProducts.map((item, idx) => <SimpleProductCard item={item} key={`${item.itemNumber}-${idx}`} onClickFunc={() => this.props.func.toggleModal()}/>) : false;
		const cartLink = this.props.storeId ? blapp.url2.getGlobalCartStoreUrl(this.props.storeId) : blapp.url2.getGlobalCartUrl();

		return (
			<div className={"modal " + classes}>
				<div className="modal__overlay" onClick={() => this.props.func.toggleModal()}></div>
				<div className="modal__content modal__content--small add-to-cart-modal">
					<div className="modal__header bg-color--cloud">
						<div className="modal__title">Added to cart</div>
						<i className="far fa-times modal__close" onClick={() => this.props.func.toggleModal()}></i>
					</div>
					<div className="modal__body">
						<div className="product-listing-item__internal l-margin-bottom">
							<div className="product-listing-item__image">
								<img src={product.image} className="l-block"/>
							</div>
							<div className="product-listing-item__info">
								<strong className="product-listing-item__name l-block">{product.name}</strong>
								{product.itemNumber ? 
									<span className="product-listing-item__number l-block">Item no: {product.itemNumber}</span>
								: null}
								{product.qty ? 
									<span className="product-listing-item__number l-block">Quantity: {product.qty}</span>
								: null}
							</div>
						</div>
						<a href={cartLink} className="btn btn--cta-alt l-full-width l-block">View cart and checkout</a>
						{this.props.moreProducts && _.size( this.props.moreProducts ) > 0 ?
							<div className="add-to-cart-modal__more l-margin-top">
								{this.props.storeLink ? 
									<strong className="l-margin-bottom--sm l-block"><a href={this.props.storeLink} className="text--inherit">Browse more items {this.props.storeName ? `from ${this.props.storeName}` : null}</a></strong>
								:
									<strong className="l-margin-bottom--sm l-block">Browse more items {this.props.storeName ? `from ${this.props.storeName}` : null}</strong>
								}
								<HiddenScroll>
									{moreProducts}
								</HiddenScroll>
							</div>
						: null}
					</div>
				</div>
			</div>
		);
	}
}

AddToCartModal.propTypes = 
	{
		classes:		PropTypes.string
	,	product: 		PropTypes.shape(
							{
								name: 		PropTypes.string
							,	image: 		PropTypes.string
							,	itemNumber: PropTypes.string
							,	qty: 		PropTypes.number
							}
						)
	,	func:			PropTypes.shape(
							{	
								toggleModal: PropTypes.func.isRequired
							}	
						)
	,	storeName:		PropTypes.string
	,	storeLink:		PropTypes.string
	,	storeId:		PropTypes.number
	,	moreProducts:	PropTypes.arrayOf(
							PropTypes.shape(
								{
									name:		PropTypes.string
								,	link:		PropTypes.string
								,	image:		PropTypes.string
								,	itemNumber:	PropTypes.string
								}
							)
						)
}